module.exports = __webpack_public_path__ + "static/media/ico_ellipse_v.32a43f83.svg";